import { render, staticRenderFns } from "./OutpatientEdit.vue?vue&type=template&id=4225f3a7"
import script from "./OutpatientEdit.vue?vue&type=script&lang=js"
export * from "./OutpatientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports